import { createStore } from 'vuex'

export default createStore({
  state: {
    userInfo: {
      token: '',
    }
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
